/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, {useState, useEffect} from 'react';
import { useHistory } from 'react-router-dom';
import * as API from '../../http/api';
import { openlightbox } from '../../util/Functions';
import moment from 'moment';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import * as FORMAT from 'react-day-picker/moment';
import * as Modals from '../modals';
import CurrencyFormat from 'react-currency-format';
import 'moment/locale/es';

const ReportLogTutuca = (props) => {
    moment.locale('es');
    const [form, setForm] = useState({
        type: '',
        data: {
            results_per_page: 1,
            page_number: 1,
            filters: {
                start_date: '',
                end_date: '',
                methodName: ''
            }
        },
    });

    const history = useHistory();
    const [initialDate, setInitialDate] = useState(new Date());
    const [endingDate, setEndingDate] = useState(new Date());
    const [initialDateEnd, setInitialDateEnd] = useState(new Date());
    const [logs, setLogs] = useState([]);
    const [selectedDates, setSelectedDates] = useState([]);
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [page, setPage] = useState(0);
    const [total, setTotal] = useState(0);
    const [maxReg, setMaxReg] = useState(0);
    const [pages, setPages] = useState(0);

    //VALIDAR SI SE VAN A USAR
    const [requestType, setRequestType] = useState('');
    const [methodName, setMethodName] = useState('');

    const [currentePage, setcurrentpage] = useState(1);
    const [pageSize, setPageSize] = useState(15);
    const [pagination,setPagination] = useState([]);

    var indexOfLastLogs = currentePage * pageSize;
    var indexOfFirstLogs = indexOfLastLogs - pageSize;
    const  [currentLogs,setCurrentLogs] = useState([]);


    useEffect(() => {
        init();
    }, []);

    const order = (list) => {
        list.sort((a, b) => {
            return new Date(a.cdate).getTime() - new Date(b.cdate).getTime();
        });
    }

    const setCreateInitialDate = (date) => {
        let initial = new Date(date);
        let timeZone = moment(initial.toJSON().substring(0, 10)).tz('America/Mexico_City').toJSON();
        setInitialDate(new Date(timeZone));
    }

    const createInitialDateEnd = (date) => {
        let initial = new Date(date);
        let timeZone = moment(initial.toJSON().substring(0, 10)).tz('America/Mexico_City').toJSON();
        setInitialDateEnd(new Date(timeZone));
    }

    const initEndsDates = (initDate, endDate) => {
        setCreateInitialDate('2016-10-03');
        if(initDate){
            setStartDate(new Date(initDate));
            createInitialDateEnd(new Date(initDate));
        }else{
            createInitialDateEnd('2016-10-03');
            setStartDate(null);
        }

        if(endDate){
            let endString = endDate.substring(0, 10);
            setEndDate(new Date(new Date(endString).getTime()));
        }else{
            setEndDate(null);
        }
        
        if(initDate && endDate){
            let dates = [];
            let diffTime = (new Date(new Date(endDate).getTime()-1)).getTime() - new Date(initDate).getTime();
            let diffDays = diffTime/(1000*3600*24);
            for(let i = 0; i<parseInt(diffDays.toString())+1; i++){
                dates.push(new Date(new Date(initDate).getTime()+((1000*3600*24)*i)));
            };
            setSelectedDates(dates);
        }
    }

    const init = () => {
        initEndsDates(props.content.startDate, props.content.endDate);
        let f = form;
        let logList = [];
        if(props.content.logs.length > 0){
            logList = props.content.logs;
            //order(logList);
        }

        setLogs(JSON.parse(JSON.stringify(logList)));
        f.type = props.content.type;
        f.data.filters.start_date = props.content.startDate;
        f.data.filters.end_date = props.content.endDate;
        f.data.filters.methodName = props.content.methodName;
        setPage(props.content.page);
        setTotal(props.content.total);
        setPages(props.content.pages);
        setMaxReg(props.content.limit);
        setForm(JSON.parse(JSON.stringify(f)));
    };

    const createDateNumbers = (y, m, d) => {
        let initial = new Date(y, m, d);
        let timeZone = moment(initial.toJSON().substring(0, 10)).tz('America/Mexico_City').toJSON();
        return new Date(timeZone).toJSON();
    }

    const createInitialDate = (date) => {
        let initial = new Date(date);
        let timeZone = moment(initial.toJSON().substring(0, 10)).tz('America/Mexico_City').toJSON();
        return new Date(timeZone).toJSON();
    }

    const changeDayInit = (data) => {
        let dates = [];
        let f = form;
        let initString = data.toJSON().substring(0, 10);
        let initial = new Date(initString);
        let today = new Date(initial);
        let startDate = createInitialDate(today.toJSON().substring(0, 10));
        f.data.filters.start_date = startDate;
        createInitialDateEnd(data.toJSON().substring(0, 10));
        if(f.data.filters.end_date){
            if(new Date(f.data.filters.end_date).getTime() < data.getTime()){
                delete f.data.filters.end_date;
                setEndDate(null);
            }else{
                let diffTime = new Date(f.data.filters.end_date).getTime() - data.getTime();
                let diffDays = diffTime/(1000*3600*24);
                for(let i = 0; i<parseInt(diffDays.toString())+1; i++){
                    dates.push(new Date(data.getTime()+((1000*3600*24)*i)));
                };
                let end = (new Date(f.data.filters.end_date).getTime())-1;
                let timeZoneEnd = moment(new Date(end).toJSON()).tz('America/Mexico_City').toJSON();
                f.data.filters.end_date = timeZoneEnd;
                setEndDate(new Date(timeZoneEnd));
            }
        }
        f.data.page_number = page;
        f.data.results_per_page = maxReg;
        setSelectedDates(dates);
        setForm(JSON.parse(JSON.stringify(f)));
        requestLog(f);
        
    }

    const changeDayEnd = (data) => {
        let dates = [];
        let f = form;
        let timeNumber = (data.getTime()+(1000*3600*24))-1;
        let end = new Date(timeNumber);
        let timeZoneEnd = moment(end.toJSON().substring(0, 10)).tz('America/Mexico_City').toJSON();
        let timeZone = new Date((new Date(timeZoneEnd).getTime())-1).toJSON();
        f.data.filters.end_date = timeZone;
        if(f.data.filters.start_date){
            let diffTime = data.getTime() - new Date(f.data.filters.start_date).getTime();
            let diffDays = diffTime/(1000*3600*24);
            for(let i = 0; i<parseInt(diffDays.toString())+1; i++){
                dates.push(new Date(new Date(f.data.filters.start_date).getTime()+((1000*3600*24)*i)));
            };
        }
        f.data.page_number = page;
        f.data.results_per_page = maxReg;
        setForm(JSON.parse(JSON.stringify(f)));
        setSelectedDates(dates);
        requestLog(f);
    }

    const requestLog = async (data) => {
        props.changeLoader(true);
        let request = await API.service('reporteLogTutuka', data, props.pos, props.changeAlert, props.changeLoader, history);
        if (request.status == 200) {
            if (request.data.data.response == 'OK') {
                props.changeWidgets([]);
                let widg = [];
                widg = request.data.data.widget;
                props.changeWidgets(JSON.parse(JSON.stringify(widg)));
            } else {
                
            }
        } else { 
            
        }
        props.changeLoader(false);
    }

    const changeSelect = (key, e) => {
        let f = form;
        if(key == 'type'){
            f.type = e.target.value;
            delete f.data.filters.methodName;
        }

        if(key == 'methodName'){
            f.data.filters[key] = e.target.value;
            if(!e.target.value){
                delete f.data.filters.methodName;
            }
        }

        f.data.page_number = page;
        f.data.results_per_page = maxReg;
        setForm(JSON.parse(JSON.stringify(f)));
        requestLog(f);
    }

    const viewDatail = async (id) => {
        let data = {
            id: id,
            type: form.type
        }
        props.changeLoader(true);
        let request = await API.service('infoLogTutuka', data, props.pos, props.changeAlert, props.changeLoader, history);
        if (request.status == 200) {
            if (request.data.data.response == 'OK') {
                let widg = [];
                widg = request.data.data.widget;
                if (widg[0]?.type === 'infoLogTutuka') {
                    let title = `Log tutuka ${form.type}`;
                    let content = widg[0]['content'];
                    let contentModal = {
                        title: title,
                        content: content,
                        type: 'infoLogTutuka'
                    }

                    /*props.changeContentModal(contentModal);
                    props.changeOpenModal(true);*/

                    const as = <Modals.InfoLogTutuka 
                        changeAlert={props.changeAlert}
                        changeLoader={props.changeLoader}
                        contentModal={contentModal}
                        key="infoLogTutuka" />
                    openlightbox(as);
                }
            } else {
                
            }
        } else { 
            
        }
        props.changeLoader(false);
    }

    const changePage = async (action) => {
        let f = form;
        if(action == 'next'){
            f.data.page_number = page+1;
            f.data.results_per_page = maxReg;
        }

        if(action == 'prev'){
            f.data.page_number = page-1;
            f.data.results_per_page = maxReg;
        }

        await requestLog(f);
        console.log('SIII');
        console.log(action);
    }

    return <div className="size-12">
        <div className="card">
            <div className="form-row hdr_transaction">
                <div className='col-ico '>
                </div>
                <h3 className='col-8 fix-elm-title-widget'>
                    Tutuka logs
                </h3> 
                <div className='col-3 txt-right fix-dos-icos'></div>
            </div>
            <div className="size-12">
                <div className="">
                    <div className="tableTools pnl-log-oper">
                        <div>
                            <label className="form-report-log-label">
                                Tipo:
                                <select id="type-log-selection" value={form.type}  onChange={changeSelect.bind(this, 'type')} >
                                    <option value="remote">Remote</option>
                                    <option value="local">Local</option>
                                </select>
                            </label>

                        
                            <label className="form-report-log-label">
                                Nombre del metodo:
                                {
                                    form.type === 'local' &&
                                    <select onChange={changeSelect.bind(this, 'methodName')} value={form.data.filters.methodName}>
                                        <option value=''>Todos</option>
                                        <option value="LoadReversal">LoadReversal</option>
                                        <option value="ActivateCard">ActivateCard</option>
                                        <option value="CreateLinkedCard">CreateLinkedCard</option>
                                        <option value="UnstopCard">UnstopCard</option>
                                        <option value="LinkCard">LinkCard</option>        
                                        <option value="OrderCardWithPinBlock">OrderCardWithPinBlock</option>
                                        <option value="GetActiveLinkedCards">GetActiveLinkedCards</option>
                                        <option value="StopCard">StopCard</option>
                                    </select>
                                }
                                {
                                    form.type === 'remote' &&
                                    <select onChange={changeSelect.bind(this, 'methodName')} value={form.data.filters.methodName}>
                                        <option value=''>Todos</option>
                                        <option value="Deduct">Deduct</option>
                                        <option value="Stop">Stop</option>
                                        <option value="DeductReversal">DeductReversal</option>
                                        <option value="LoadAdjustment">LoadAdjustment</option>
                                        <option value="LoadReversal">LoadReversal</option>
                                    </select>
                                }
                            </label>
                            <label className="form-report-log-label">
                                Fecha de inicio
                                <DayPickerInput
                                    style={{height: '30px', width: '100%'}}
                                    onDayChange={changeDayInit}
                                    placeholder='Inicio'
                                    format="DD-MM-YYYY"
                                    inputProps={{
                                        readOnly: true
                                    }}
                                    value={startDate}
                                    formatDate={FORMAT.default.formatDate}
                                    parseDate={FORMAT.default.parseDate}
                                    dayPickerProps={{
                                        months: ["Ene", "Feb", "Mar","Abr", "May", "Jun","Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
                                        fixedWeeks: false,
                                        pagedNavigation: true,
                                        numberOfMonths: 1,
                                        disabledDays: {
                                            before: initialDate,
                                            after: endingDate,
                                        },
                                        selectedDays: selectedDates,
                                    }}
                                />
                            </label>
                            
                            <label className="form-report-log-label">
                                Fecha final
                                <DayPickerInput
                                    style={{height: '30px', width: '100%'}}
                                    onDayChange={changeDayEnd}
                                    placeholder='Fin'
                                    format="DD-MM-YYYY"
                                    inputProps={{
                                        readOnly: true
                                    }}
                                    value={endDate}
                                    formatDate={FORMAT.default.formatDate}
                                    parseDate={FORMAT.default.parseDate}
                                    dayPickerProps={{
                                        months: ["Ene", "Feb", "Mar","Abr", "May", "Jun","Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
                                        pagedNavigation: true,
                                        numberOfMonths: 1,
                                        disabledDays: {
                                            before: initialDateEnd,
                                            after: endingDate
                                        },
                                        selectedDays: selectedDates
                                    }}
                                />
                            </label>
                            {/*<div className="inputIconRight inputGroup desktop">
                                <select value={agent} onChange={changeAgent.bind(this)}>
                                    <option value="">Agente</option>
                                    {
                                        agents.map((item, iData) => {
                                            return <option value={item.uuid} label={item.name} key={iData}>{item.name}</option>
                                        })
                                    }
                                </select>
                            </div>*/}
                        </div>

                        <div className="animated">
                            <div>
                                <span className="neutral">{total > 0 ? ((page-1)*maxReg)+1 : 0} - {total > 0 ? ((maxReg*page) > total ? total : (maxReg*page)) : 0} de {total}</span>
                                {
                                    page > 1 &&
                                    <i className="tap ibon-chevron-left indigo" onClick={changePage.bind(this, 'prev')}></i>
                                }
                                {
                                    ((page < pages) && (pages > 0)) &&
                                    <i className="tap ibon-chevron-right indigo" onClick={changePage.bind(this, 'next')}></i>
                                }
                            </div>
                        </div>
                    </div>
                    <div className='fx-conten-table-logic'>
                        <div className={''}>
                            <div className={''}>
                                <div className='container-table-default'>
                                    <table>
                                        <thead>
                                            {
                                                form.type == 'local' &&
                                                <tr>
                                                    <th className="neutral">Fecha</th>
                                                    <th className="neutral">Method Name</th>
                                                    <th className="neutral">ID de transacción</th>
                                                    <th className="neutral">Detalles</th>
                                                </tr>

                                            }
                                            {
                                                form.type == 'remote' &&
                                                <tr>
                                                    <th className="neutral">Fecha</th>
                                                    <th className="neutral">Method Name</th>
                                                    <th className="neutral">Monto</th>
                                                    <th className="neutral">Tracking key</th>
                                                    <th className="neutral">Wallet</th>
                                                    <th className="neutral">Detalles</th>
                                                </tr>

                                            }
                                        </thead>
                                        <tbody>
                                            {
                                                logs.map((log, index) => {
                                                    if(form.type == 'local'){
                                                        return <tr key={`tr-${index}`}>
                                                            <td>
                                                                {moment(new Date(log.cdate)).format('LLL')}
                                                            </td>
                                                            <td>{log.methodName}</td>
                                                            <td>{log.transaction_id}</td>
                                                            <td>
                                                                <span onClick={viewDatail.bind(this, log['id'])} className={`fa fa-ellipsis-v tap fx-mrg-ibon`}></span>
                                                            </td>
                                                        </tr>
                                                    }

                                                    if(form.type == 'remote'){
                                                        return <tr key={`tr-${index}`}>
                                                            <td>
                                                                {moment(new Date(log.cdate)).format('LLL')}
                                                            </td>
                                                            <td>{log.methodName}</td>
                                                            <td>
                                                                <CurrencyFormat
                                                                    value={
                                                                        !log.hasOwnProperty('amount') ? '0.00' :
                                                                        log.amount.toString().indexOf('.') > -1 ? log.amount : `${log.amount}.00`
                                                                    }
                                                                    displayType={'text'}
                                                                    thousandSeparator={true}
                                                                    decimalSeparator={'.'}
                                                                    prefix={'$'}
                                                                    renderText={
                                                                        value => <p>{value}</p>
                                                                    }
                                                                />
                                                            </td>
                                                            <td>{log.tracking_key}</td>
                                                            <td>{log.wallet}</td>
                                                            <td>
                                                                <span onClick={viewDatail.bind(this, log['id'])} className={`fa fa-ellipsis-v tap fx-mrg-ibon`}></span>
                                                            </td>
                                                        </tr>
                                                    }
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
}

export default ReportLogTutuca;
